import { render, staticRenderFns } from "./nutrition.vue?vue&type=template&id=ceb3d988&scoped=true&"
import script from "./nutrition.vue?vue&type=script&lang=js&"
export * from "./nutrition.vue?vue&type=script&lang=js&"
import style0 from "./nutrition.vue?vue&type=style&index=0&id=ceb3d988&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ceb3d988",
  null
  
)

export default component.exports